import * as React from "react"

interface State {
    isOnline: boolean
}

export interface NetworkStatusContextInterface {
    isOnline: boolean
}

interface Props {}

export const NetworkStatusContext = React.createContext<NetworkStatusContextInterface | null>(null)

class NetworkStatusProvider extends React.PureComponent<Props, State> {
    state = {
        isOnline: true,
    }

    updateNetworkStatus = () => {
        this.setState({
            isOnline: navigator.onLine,
        })
    }

    componentDidMount = () => {
        window.addEventListener("online", this.updateNetworkStatus)
        window.addEventListener("offline", this.updateNetworkStatus)
        this.updateNetworkStatus()
    }

    componentWillUnmount = () => {
        window.removeEventListener("online", this.updateNetworkStatus)
        window.removeEventListener("offline", this.updateNetworkStatus)
    }

    render = () => (
        <NetworkStatusContext.Provider
            value={{
                isOnline: this.state.isOnline,
            }}>
            {this.props.children}
        </NetworkStatusContext.Provider>
    )
}

const NetworkStatusConsumer = NetworkStatusContext.Consumer

export { NetworkStatusConsumer, NetworkStatusProvider }
